import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class stdClassListService {
  static async getClassList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async saveClassList(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClass', payload))
    return Callback(err, res)
  }
  static async updateClassList(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClass', payload))
    return Callback(err, res)
  }
  static async classDetail(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/api/std/StdClass/?id=${payload.id}`))
    return Callback(err, res)
  }
  static async publish(payload) {
    RecordOperation({ type: 'update' })
    console.log(payload)
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/publish?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async updateApproveStatus(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/update_approve_status?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async classRemove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance('/api/std/StdClass', {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async getAttrList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async saveAttrList(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async getStandardAttrList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async updateAttrList(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
}
